<template>
  <sc-modal :active="isActive" @close="closeCallback" :can-cancel="false">
    <sc-modal-card title="Excluir certificado digital">
      <template slot="body">
        <div class="info-texts">
          <p>Tem certeza que deseja excluir o certificado digital?</p>
          <p>Ao excluir o certificado digital do selecionado, não iremos mais consultar os CT-es emitidos na SEFAZ.</p>
          <p>Os CT-es já consultados continuarão disponíveis para consulta no TMS</p>
        </div>
      </template>
      <template slot="footer">
        <sc-button
          theme="default"
          text="Voltar"
          :inverted="true"
          @click="() => closeCallback()"
        />
        <sc-button
          theme="danger"
          text="Excluir certificado"
          @click="() => excludeCallback()"
        />
      </template>
    </sc-modal-card>
  </sc-modal>
</template>
<script>
  import {
    ScModal,
    ScModalCard,
    ScButton,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'ScExcludeCertificateModal',
    props: {
      isActive: {
        type: Boolean,
        required: true,
      },
      closeCallback: {
        type: Function,
        required: true,
      },
      excludeCallback: {
        type: Function,
        required: true,
      },
    },
    components: {
      ScModal,
      ScModalCard,
      ScButton,
    },
  };
</script>
<style scoped>
  .info-texts p {
    margin: 10px;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/configuration-sefaz/components/sc-exclude-certificate-modal/ScExcludeCertificateModal.vue?62fd9559